module.exports = __webpack_public_path__ + "img/segment_creditor.eaa4c6a7.png";